import { gql, useLazyQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SEARCH_PROFILE } from "../graphql/query/profiles";
import { setTokens } from "../redux/actions/auth";
import { message } from "antd";
import { authenticate } from "../utils/helpers/provider";
import Lottie from "react-lottie";
import HorizontalLoader from "../imgs/horizontalprogressbar.json";
import { userTokenData } from "../utils/helpers/google";

const SocialAuth = ({ history, location }) => {
  const [authToken, setAuthToken] = useState(null);
  const [userData, setUserData] = useState(null);
  const strapiRes = useSelector(state => state.strapiRes)

  const dispatch = useDispatch();

  const { pathname, search } = location;

  const accountType = pathname.split("/")[2];

  const searchSplit = search?.split("access_token%5D=")[1];

  const accessToken = searchSplit?.split("&raw%5Bexpires_in%5D")[0];

  const [getProfileByEmail] = useLazyQuery(gql(SEARCH_PROFILE), {
    fetchPolicy: "network-only",
    onCompleted: (data) => queryCallBackHandler(data),
    onError: (error) => {
      console.warn(error);
    },
  });

  useEffect(() => {
    authHandler();
  }, []);

  const authHandler = async () => {
    const { jwt, user, error, message } = await authenticate(pathname, search);
    if (error) {
      const {
        messages: [{ message: errorMessage, id }],
      } = message[0];

      if (id === "Auth.form.error.invalid")
        return displayError("Incorrect email or password!");

      if (id === "Auth.form.error.email.taken")
        return displayError("Email already taken");

      if (id === "Auth.form.error.blocked") return displayError(errorMessage);
    }

    if (user?.blocked) {
      return displayError("Your account has been blocked by an administrator");
    }

    localStorage.setItem("authToken", jwt);

    setAuthToken(jwt);
    setUserData(user);

    getProfileByEmail({ variables: { email: user?.email } });
  };

  const displayError = (errorMessage) => {
    message.error(errorMessage);
    localStorage.clear();
    // history.push(`/${authRoute}`);
  };

  const queryCallBackHandler = async ({ searchProfileByEmail }) => {
    if (searchProfileByEmail?.length) {
      dispatch(
        setTokens({
          authToken,
          accessToken: null,
        })
      );

      history.push(`/${strapiRes.userName}`);
    } else {
      try {
        let user = await userTokenData(accessToken);
        const { email, id } = user;

        let userId = user.id.slice(user.id.length - 2);

        await localStorage.setItem("accessToken", accessToken);
        await localStorage.setItem("accountType", accountType);
        await localStorage.setItem("email", email);
        await localStorage.setItem("userId", userId);

        dispatch(
          setTokens({
            authToken: authToken,
            accessToken: accessToken,
          })
        );
        if (email) history.push("/userdetails");
      } catch (error) {
        message.error("Some error occured, signin again");
        localStorage.clear();
        dispatch(setTokens({ authToken: null, accessToken: null }));
        history.push("/login");
      }
    }
  };

  return (
    <div className="container">
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData: HorizontalLoader,
        }}
        height={500}
        width={500}
      />
    </div>
  );
};

export default SocialAuth;
